// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';

// Firebase設定
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// アプリの初期化
const app = initializeApp(firebaseConfig);

// 認証サービス
const auth = getAuth(app);

// 複数のデータベース
const mainDatabase = getDatabase(app); // デフォルトDB
const contentUsersDatabase = getDatabase(app, 'https://content-users-db-4dd9.firebaseio.com/'); // コンテンツDB

export { app, auth, mainDatabase, contentUsersDatabase };